<template>
  <!--导入功能模板-->
  <el-dialog title="导入数据" width="80%" :close-on-click-modal="false" append-to-body :visible.sync="visible"
             v-if="visible">
    <el-steps class="m_b1" :active="step" align-center>
      <el-step title="上传文件" description="根据要求上传文件"></el-step>
      <el-step title="文件预览" description="预览上传文件内容"></el-step>
      <el-step title="执行导入" description="数据导入至服务器"></el-step>
      <el-step title="导入结果" description="完成数据批量导入"></el-step>
    </el-steps>
    <div v-show="step == 0">
      <div v-loading="pageLoading" element-loading-text="文件上传中...">
        <div class="flex_l_c b_d" v-if="!returnList.length">
          <div class="el-icon-download"></div>
          <div class="uploadInfo">
            <div>填写导入数据的信息</div>
            <div class="tips">请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，单次导入的数据不超过1000条。</div>
            <el-link type="primary" size="small" @click="downloadTemplate">下载模板</el-link>
          </div>
        </div>
        <div class="flex_l_c b_d">
          <div class="el-icon-upload2"></div>
          <div class="uploadInfo">
            <div>上传填好的数据信息表</div>
            <div class="tips">文件后缀名必须为xls或xlsx（即Excel格式），文件大小不得大于10M。</div>
            <div class="flex_l_c" v-if="!fileList.length">
              <el-upload v-if="visible" action="action" :limit="1" accept=".xls, .xlsx" :file-list="fileList"
                         :show-file-list="false" :http-request="uploadFile" :beforeUpload="beforeUploadFile">
                <el-button size="small" type="primary">上传文件</el-button>
              </el-upload>
            </div>
            <div class="flex_l_c fileListBox" v-else>
              <div class="m_r2">{{fileList[0].name}}</div>
              <div class="el-icon-close" @click="delFile"></div>
            </div>
          </div>
        </div>
        <div class="flex_l_c b_d" v-if="returnList.length">
          <div class="el-icon-warning"></div>
          <div class="uploadInfo">
            <div class="p_b1">正常数量条数：<span class="greenColor">{{successNum}}条</span></div>
            <div>异常数量条数：<span class="redColor">{{failNum}}条</span></div>
          </div>
        </div>
      </div>
      <div class="errorBox" v-if="returnList.length">
        <div class="fontSize12 p_t1">异常提示：</div>
        <div class="errorItem" v-for="(item, index) in returnList" :key="index">{{item}}</div>
      </div>
    </div>
    <div v-show="step == 1">
      <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
               @keyup.enter.native="refreshList(1)" @submit.native.prevent>
        <el-form-item prop="keyword" label="关键字：">
          <el-input v-model.trim="searchForm.keyword" maxlength="50" placeholder="输入关键字（限50字）" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getSaveCache(1)" size="small" icon="el-icon-search">查询</el-button>
          <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
              :data="dataList"
              size="small" height="380"
              class="table" ref="multipleTable" border
              @selection-change="selectionChangeHandle" row-key='id' v-loading="loading">
        <el-table-column type="selection" :reserve-selection='true' fixed/>
        <el-table-column v-for="(item, index) in tableList" :key="index"
                         :prop="item.basicCode"
                         :label="item.basicRename"
                         show-overflow-tooltip min-width="100">
          <template slot-scope="scope">
            <span>{{listDataFormat(item, scope.row.jsonData[item.basicCode])}}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="total"
        :page.sync="searchForm.current"
        :limit.sync="searchForm.size"
        @pagination="getSaveCache"
      />
    </div>
    <div v-if="step == 2" class="importData">
      <el-progress :percentage="importProgress" :stroke-width="20"></el-progress>
      <div class="text_center importTips">{{ tipTxt }}</div>
    </div>
    <el-result v-if="step == 4" icon="success" title="导入成功！">
      <template slot="extra">
        <div class="totalTips">成功导入 <span class="total">{{total}}</span> 条藏品数据。</div>
<!--        <el-button size="small" type="primary" @click="dataMatching()">数据匹配</el-button>-->
      </template>
    </el-result>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" plain v-if="step == 1" @click="prev()">上一步</el-button>
      <el-button size="small" type="primary" :disabled="step == 0 && !fileList.length" @click="next()" v-if="step == 0 && !returnList.length">下一步</el-button>
      <el-button size="small" type="primary" @click="next()" v-if="step == 1">直接上传</el-button>
      <el-button size="small" plain @click="init(configId, basicDataId, tableList)" v-if="step == 4">再次上传</el-button>
      <el-button size="small" type="primary" @click="next()" v-if="step == 4">完成</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        pageLoading: false,
        visible: false,
        configId: '',
        basicDataId: '',
        functionId: '',
        step: 0,
        successNum: 0,
        failNum: 0,
        returnList: [],
        fileList: [],
        dataList: [],
        dataListSelections: [],
        tableList: [],
        total: 0,
        searchForm: {
          keyword: '',
          cacheKey: '',
          current: 1,
          size: 20
        },
        importProgress: 1,
        tipTxt: '正在导入数据'
      }
    },
    methods: {
      init(configId, basicDataId, tableList, functionId) {
        this.configId = configId
        this.basicDataId = basicDataId
        this.tableList = tableList
        this.functionId = functionId
        this.step = 0
        this.importProgress = 1
        this.tipTxt = '正在导入数据'
        this.returnList = []
        this.fileList = []
        this.pageLoading = false
        this.visible = true
      },
      // 下载模板
      downloadTemplate() {
        this.exportExcel(this.api.metadata.exportModelDownload, {configId: this.configId, basicDataId: this.basicDataId, fileName: '导入模板'}, '导入模板', 'get')
      },
      // 上传文件
      uploadFile(param) {
        this.returnList = []
        this.pageLoading = true
        const formData = new FormData()
        formData.append('file', param.file)
        formData.append('configId', this.configId)
        formData.append('basicDataId', this.basicDataId)
        this.$axios(this.api.metadata.excelImport, formData, 'post').then(res => {
          if(res.status) {
            if(res.data.cacheKey) {
              this.fileList = [{ name: param.file.name }]
              this.searchForm.cacheKey = res.data.cacheKey
              this.total = res.data.totalNum
              this.$message.success('上传成功')
            } else {
              this.fileList = []
              this.returnList = res.data.errorList
            }
          } else {
            this.fileList = []
            this.$message.error(res.msg)
          }
          this.pageLoading = false
        })
      },
      beforeUploadFile(file) {
        const isLt2M = file.size / 1024 / 1024 <= 10
        if (!isLt2M) {
          this.$message.error("上传文件大小不能超过 " + "10MB!");
          return false
        }
      },
      // 查询上传结果
      getSaveCache(type) {
        if (type == 1) {
          this.searchForm.current = 1
        }
        this.loading = true
        this.$axios(this.api.metadata.cacheKeyList, this.searchForm).then(res => {
          if(res.status) {
            this.dataList = res.data.data
            this.total = parseInt(res.data.total)
          } else {
            this.$message.error(res.msg)
          }
          this.loading = false
        })
      },
      //执行导入
      executeImport() {
        let timer = setInterval(() => {
          let situation = Math.floor(Math.random() * (0 - 10) + 10)
          this.importProgress += situation
          if (this.importProgress > 80) {
            clearInterval(timer)
          }
        }, 500)
        let dataId = []
        dataId = this.dataListSelections.map(item => {
          return item.id
        })
        this.$axios(this.api.metadata.saveExportData, {
          dataId,
          cacheKey: this.searchForm.cacheKey,
          configId: this.configId,
          basicDataId: this.basicDataId,
          functionId: this.functionId,
        }, 'post').then(res => {
          if(res.status) {
            clearInterval(timer)
            this.importProgress = 100
            this.total = res.data.successNum
            this.tipTxt = '数据导入成功'
            this.step = 4
          } else {
            clearInterval(timer)
            this.tipTxt = '数据导入失败'
            this.$message.error(res.msg)
          }
        })
      },
      // 删除上传文件
      delFile() {
        this.fileList = []
      },
      // 上一步
      prev() {
        this.$refs.multipleTable.clearSelection()
        if (this.step > 0) {
          this.step--
        }
      },
      // 下一步
      next() {
        this.step++
        if (this.step == 1) {
          this.reset()
          return
        }
        if (this.step == 2) {
          this.executeImport()
          return
        }
        if (this.step == 5) {
          this.visible = false
          this.$emit('refreshData', this.dataList)
        }
      },
      // 数据匹配
      dataMatching() {

      },
      // 多选
      selectionChangeHandle(val) {
        this.dataListSelections = val
      },
      // 重置
      reset() {
        this.dataListSelections = []
        this.$refs.searchForm.resetFields();
        this.$refs.multipleTable.clearSelection()
        this.getSaveCache(1)
      }
    }
  }
</script>

<style scoped>
  .el-icon-upload2, .el-icon-download, .el-icon-warning {
    background: #eeeeee;
    height: 100px;
    line-height: 100px;
    padding: 0 30px;
    font-size: 30px;
    color: #000;
    border-right: 1px solid #DCDCDC;
  }

  .el-icon-warning {
    color: #e6a23c;
  }

  .uploadInfo {
    padding: 8px 20px;
  }

  .tips {
    font-size: 12px;
    color: #999999;
    margin-top: 4px;
    margin-bottom: 10px;
  }

  .fileListBox {
    font-size: 12px;
  }

  .el-icon-close {
    font-size: 14px;
    cursor: pointer;
    color: #1890ff;
    margin-top: 4px;
  }

  .totalTips {
    font-size: 12px;
    color: grey;
    margin-top: -20px;
    margin-bottom: 20px;
  }

  .total {
    color: red;
  }

  .importData {
    width: 80%;
    margin: 60px auto 40px;
  }

  .errorBox {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 20px;
    line-height: 22px;
  }

  .errorItem {
    font-size: 12px;
    color: red;
  }
</style>
